export default __webpack_public_path__ + "static/media/Punto_05_Scali_Rosciano_SPA_Def.91e664ae.aac";